// ============================================================================
// AuditStatusBar.tsx — СИСТЕМНЫЕ аудит-поля записи (Создал / Дата создания /
// Изменил / Дата изменения) ОДНОЙ горизонтальной строкой В САМОМ НИЗУ формы
// (ObjectFormBody — после содержимого макета). ЕДИНАЯ точка для автоформ
// И кастомных форм: в потоке полей макета аудит-поля НЕ выводятся (нет дублей,
// нет рамок группы). Представления резолвит СЕРВЕР (created_by/updated_by →
// имя; {col}_presentation), даты — единым механизмом lib/format. Рендерится
// только для СОХРАНЁННЫХ записей (гейт — на вызывающей стороне по objectId).
//
// ОФОРМЛЕНИЕ (требование 2026-10-15): штатный ШРИФТ ТЕМЫ (наследуется, без
// хардкод-размера) — text-xs как у подписей формы; строка НЕ переносится
// (flex-nowrap) и НЕ создаёт горизонтального скролла (overflow-hidden +
// truncate); при нехватке места значение усекается, полный текст — в title.
// ============================================================================

import { formatValue } from '@/lib/format';
import { useT } from '@/lib/i18n';

export function AuditStatusBar({ data }: { data: Record<string, unknown> }) {
  const t = useT();
  const by = (col: string): string => {
    const v = data[col + '_presentation'] ?? data[col];
    return v === undefined || v === null || String(v) === '' ? '—' : String(v);
  };
  const at = (col: string): string => formatValue(data[col], '', 'timestamp') || '—';
  const item = (label: string, value: string) => (
    <span className="flex min-w-0 items-baseline gap-1 whitespace-nowrap">
      <span className="shrink-0">{label}</span>
      <span className="truncate font-medium text-foreground/80" title={value}>{value}</span>
    </span>
  );
  const values = [by('created_by'), at('created_at'), by('updated_by'), at('updated_at')];
  // «Статус изменён» — у задач/заявок (сервер пишет при КАЖДОЙ смене статуса);
  // у объектов без такого реквизита элемент не выводится (честно, без «—»).
  const statusRaw = data['status_changed_at'];
  const hasStatusChanged = statusRaw !== undefined && statusRaw !== null && String(statusRaw) !== '';
  const statusChanged = hasStatusChanged ? at('status_changed_at') : '';
  const fullTitle =
    `${t('audit.created_by')}: ${values[0]} · ${t('audit.created_at')}: ${values[1]} · ` +
    `${t('audit.updated_by')}: ${values[2]} · ${t('audit.updated_at')}: ${values[3]}` +
    (hasStatusChanged ? ` · ${t('audit.status_changed')}: ${statusChanged}` : '');
  return (
    <div
      className="flex w-full min-w-0 flex-nowrap items-center gap-x-3 overflow-hidden whitespace-nowrap text-xs leading-5 text-muted-foreground"
      title={fullTitle}
    >
      {item(`${t('audit.created_by')}:`, values[0])}
      {item(`${t('audit.created_at')}:`, values[1])}
      {item(`${t('audit.updated_by')}:`, values[2])}
      {item(`${t('audit.updated_at')}:`, values[3])}
      {hasStatusChanged && item(`${t('audit.status_changed')}:`, statusChanged)}
    </div>
  );
}
